<template>
	<div class="innerBox">
		<h2 class="mb-4">Pengunaan Sparepart</h2>

		<div class="row row-space mt-4 pl-2 pr-2" >
			<div class="col-6">
				<div class="border pl-3 pr-3 pt-4 pb-4 rounded" :class="{'border-secondary' : manual , 'border-primary bg-lg-grey' : !manual}" @click="manual = 0">
					<div class="row">
						<div class="col-4 text-center">
							<i class="fa fa-qrcode fa-3x"></i>
						</div>
						<div class="col-8 flexify">
							<h4>Input Menggunakan Kode QR</h4>
						</div>
					</div>
				</div>
			</div>
			<div class="col-6">
				<div class="border pl-3 pr-3 pt-4 pb-4 rounded" :class="{'border-secondary' : !manual , 'border-primary bg-lg-grey' : manual}" @click="manual = 1">
					<div class="row">
						<div class="col-4 text-center">
							<i class="fa fa-keyboard fa-3x"></i>
						</div>
						<div class="col-8 flexify">
							<h4>Input Manual Kepada System</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="mt-3 pl-2 pr-2" v-if="!manual">
			<h5>Scan QR Barang</h5>
			<input type="text" class="form-control mt-3" v-model="qrcode" maxlength="11"/>
			<label class="mt-1 text-red">{{showErrorMessage}}</label>
			

			<div v-if="resultSearch.length > 0">
				<hr>
				<div class="row">
					<div class="col-lg-4 col-12 mt-auto mb-auto pl-3">
						<h5>Hasil Pencarian Kode QR</h5>
					</div>
					<div class="offset-lg-5 col-lg-3 col-12">
						<button
							class="btn btn-primary w-100"
							@click="processInventory()"
						>
							Selesai
						</button>
					</div>
				</div>

				<div class="mt-3">
					<label class="label">Pilih Pekerja<span style="color: red;">*</span></label>
					<MultiSelect 
						:options="options.laborer.map(x => x.id)"
						:custom-label="opt => options.laborer.find(x => opt == x.id).name"
						v-model="labourer_id"
					/>
				</div>

				<div class="mt-3">
					<label class="label">Pilih Work Order (Berlaku Untuk Bahan)<span style="color: red;">*</span></label>
					<Multiselect 
						v-if="woList"
						:options="woList.map(x => x.form_code)"
						:custom-label="opt => woList.find(x => x.form_code == opt).col_name"
						v-model="bahanWO"
						:allow-empty="false"
					/>
				</div>
				

				<!-- {{resultSearch}} -->
				<div class="row">
					<div class="col-lg-6 col-12 p-10 mt-4" v-for="(resultData , index) in resultSearch" >
						<div class="innerBox" style="min-height:400px;">
							<div style="display:flex;flex-direction:row-reverse;">
								<button
									class="btn btn-danger"
									@click="resultSearch.splice(index , 1)"
								>
									<i class="fa fa-times-circle"></i>
								</button>
							</div>
							<div class="row mt-2">
								<div class="col-4">
									<label>Tipe Barang</label>
									
								</div>
								<div class="col-1">
									:
								</div>
								<div class="col-7 mt-1">
									<h6>{{translatorSparepart.find(x => x.sparepart_type_id == resultData.sparepart_type).type_name}}</h6>
								</div>
							</div>
							<div class="row mt-2">
								<div class="col-4">
									<label>Nama Sparepart</label>
									
								</div>
								<div class="col-1">
									:
								</div>
								<div class="col-7 mt-1">
									<h6>{{resultData.sparepart_name}}</h6>
								</div>
							</div>
							<!-- {{resultSearch}} -->
							<template v-if="resultData.sparepart_type == 2">
								<div>
									<div class="row mt-2">
										<div class="col-4">
											<label>Deskripsi Sparepart</label>
											
										</div>
										<div class="col-1">
											:
										</div>
										<div class="col-7 mt-1">
											<h6>{{resultData.part_description}}</h6>
										</div>
									</div>
									<div class="row mt-2">
										<div class="col-4">
											<label>Status Barang</label>
											
										</div>
										<div class="col-1">
											:
										</div>
										<div class="col-7 mt-1">
											<h6>{{resultData.is_arrived ? 'Barang Telah Sampai' : 'Menunggu Kedatangan Sparepart'}} ({{resultData.time_of_arrival ? moment(resultData.time_of_arrival).format('DD MMM, Y HH:mm') : '-'}})</h6>
										</div>
									</div>
									<div class="row mt-2">
										<div class="col-4">
											<label>Deskripsi Mobil</label>
											
										</div>
										<div class="col-1">
											:
										</div>
										<div class="col-7 mt-1">
											<h6>{{resultData.work_order_code}} - {{resultData.car_name}}</h6>
										</div>
									</div>
								</div>
							</template>
							<template v-else-if="resultData.sparepart_type == 3">
								<div>
									<div class="row mt-2">
										<div class="col-4">
											<label>Jumlah Stok</label>
											
										</div>
										<div class="col-1">
											:
										</div>
										<div class="col-7 mt-1">
											<h6>{{resultData.sisa_stock_bahan}}</h6>
										</div>
									</div>

									<div class="row mt-2">
										<div class="col-4 mt-auto mb-auto">
											<label>Isi Jumlah Terpakai</label>
											
										</div>
										<div class="col-1 mt-auto mb-auto">
											:
										</div>
										<div class="col-7">
											<h6>
												<input type="text" v-model="resultData.used_amount" class="input--style-4"/>
											</h6>
										</div>
									</div>

									<div class="row mt-2">
										<div class="col-4">
											<label>Akhir Sisa Stok</label>
											
										</div>
										<div class="col-1">
											:
										</div>
										<div class="col-7 mt-1">
											<h6>
												{{parseFloat(resultData.sisa_stock_bahan) - parseFloat(resultData.used_amount ? resultData.used_amount : 0)}}
											</h6>
										</div>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>

				<div class="w-100" style="display:none">
					<h5>Bukti Foto Pemakaian Bahan</h5>
					<web-cam 
						:height="'100%'"
						:width="'100%'"
						:autoplay="true"
						:selectFirstDevice="true"
						ref="webcam"
					/>
				</div>
			</div>
		</div>

		<div v-if="manual" class="mt-4">
			<div class="row">
				<div class="col-12 pl-3 pr-3">
					<h5>Pilih Work Order</h5>
					<Multiselect 
						v-if="woList"
						:options="woList.map(x => x.form_code)"
						:custom-label="opt => woList.find(x => x.form_code == opt).col_name"
						v-model="workOrderCode"
						:allow-empty="false"
					/>
				</div>
			</div>
			
			<div class="row row-space mt-4 pl-2 pr-2" v-if="workOrderCode">
				<div class="col-6">
					<div class="border pl-3 pr-3 pt-4 pb-4 rounded" :class="{'border-secondary ' : sparepart_type != 'P' , 'border-primary bg-lg-grey' : sparepart_type == 'P'}" @click="sparepart_type = 'P'">
						<div class="row">
							<div class="col-4 text-center">
								<i class="fa fa-tools fa-3x"></i>
							</div>
							<div class="col-8 flexify">
								<h4>Catet Penggunaan Part</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="col-6">
					<div class="border pl-3 pr-3 pt-4 pb-4 rounded" :class="{'border-secondary ' : sparepart_type != 'B' , 'border-primary bg-lg-grey' : sparepart_type == 'B'}" @click="sparepart_type = 'B'">
						<div class="row">
							<div class="col-4 text-center">
								<i class="fa fa-boxes fa-3x"></i>
							</div>
							<div class="col-8 flexify">
								<h4>Catet Penggunaan Bahan</h4>
							</div>
						</div>
					</div>
				</div>
			</div>

			<bahan 
				v-if="sparepart_type == 'B' && workOrderCode"
				:dataJasa="jasaList"
				:workOrderCode="workOrderCode"
				:usageList="usageList"
				@updateInventoryUsage="getInventoryUsageWO"
			/>

			<part 
				v-if="sparepart_type == 'P' && estimatorSparepartData"
				:estimatorSparepartData="estimatorSparepartData"
				:usageList="usageList"
				:workOrderCode="workOrderCode"
				@reloadTable="reloadTable"
			/>
		</div>

		
		

		<!-- -->
		
	</div>
</template>

<script>
import bahan from './childComponents/bahan.vue'
import part from './childComponents/part.vue'
import moment from 'moment'

import Multiselect from 'vue-multiselect'
import Temp from '../../Finance/Payment/children/Temp.vue'
import debounce from 'debounce'
import { WebCam } from "vue-web-cam";
import env from '@/env.js'

export default {
	data () {
		return {
			moment,
			sparepart_type : 'B',
			workOrderCode : null,
			woList : null,
			estimatorSparepartData : null,
			jasaList : null,
			estimatorSparepartData : null,
			manual : 1,
			usageList : [],
			qrcode : '',
			showErrorMessage : '',
			resultSearch : [],
			translatorSparepart : [{
				sparepart_type_id : 3,
				type_name : 'Bahan'
			},{
				sparepart_type_id : 2,
				type_name : 'Sparepart'
			}],
			options : this.$store.getters.getFilterOptions,
			labourer_id : null,
			bahanWO : null
		}
	},
	components : {
		bahan,
		part,
		Multiselect,
		WebCam
	},
	mounted () {
		this.getListOfWorkOrder()

		if(this.$route.query.form_code) {
			this.workOrderCode = this.$route.query.form_code
		}
	},
	watch : {
		workOrderCode : async function () {
			// get Estimation Sparepart List 
			if(this.workOrderCode != null){	
				this.getEstimationDetails()
				this.getInventoryUsageWO()
			}
				
		},
		qrcode : function () {
			if(this.qrcode == ''){
				this.showErrorMessage = ''
				return
			}

			this.debounceSearchQRcode(this)
		}
	},
	methods : {
		async takePicture() {
			let b64Data = this.$refs.webcam.capture().split('data:image/jpeg;base64,')[1]
			

			let contentType = 'image/jpeg';
			let sliceSize = 1024;

			var byteCharacters = atob(b64Data);
			var byteArrays = [];

			for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
				var slice = byteCharacters.slice(offset, offset + sliceSize);

				var byteNumbers = new Array(slice.length);
				for (var i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}

				var byteArray = new Uint8Array(byteNumbers);

				byteArrays.push(byteArray);
			}

			var blob = new Blob(byteArrays, {type: contentType});
			const blobUrl = URL.createObjectURL(blob);
			return blobUrl;

		},
		async processInventory () {
			if(!this.labourer_id) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Diisi Pekerja Terlebih Dahulu Sebelum Menyelesaikan Pencatatan dan Sparepart!']);
				return
			}
			
			let checkAdaBahan = this.resultSearch.find(x => x.sparepart_type == 3)

			if(checkAdaBahan && !this.bahanWO) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Diisi Nomor Work Order Terlebih Dahulu Sebelum Menyelesaikan Pencatatan Bahan!']);
				return
			}

			let checkBahanKosong = this.resultSearch.find(x => parseInt(x.used_amount) == 0 || isNaN(x.used_amount))

			if(checkBahanKosong) {
				this.$store.dispatch('triggerAlert' , [false , `Mohon Diisi Jumlah Pemakaian Bahan ${checkBahanKosong.sparepart_name} Terlebih Dahulu Sebelum Menyelesaikan Pencatatan Bahan!`]);
				return
			}


			let data = await this.takePicture();
			let imageUrl = await this.submitPic(data);

			let labourer_id = this.labourer_id

			let bahanModel = {
				sparepart_id : null,
				used_amount : 0,
				amount : 0,
				price_per_item : 0,
				transaction_description : '',
				sign_pic : imageUrl,
				labourer_id : labourer_id,
				workorder_code : this.bahanWO
			}

			let partModel = {
				sparepart_id : null,
				used_amount : 0,
				amount : 0,
				price_per_item : 0,
				transaction_description : '',
				sign_pic : imageUrl,
				labourer_id : labourer_id,
				workorder_code : null,
				name : null,
				status : 'is_used'
			}

			let partEstimation = {
				estimation_id : null,
				is_used : true,
				is_used_date : new moment().format('Y-MM-DD')
			}

			let copyResultSearch = JSON.parse(JSON.stringify(this.resultSearch))

			for(var i = 0 ; i < copyResultSearch.length ; i++) {
				let curSearch = copyResultSearch[i]

				let flag = true

				if(curSearch.sparepart_type == 3) {
					let newObject = Object.assign({} , bahanModel)
					newObject.sparepart_id = curSearch.sparepart_id
					newObject.amount = parseInt(curSearch.used_amount) * -1
					newObject.transaction_description = `Pemakaian Barang ${curSearch.sparepart_name} di ${this.bahanWo}`
					flag = await this.useBahan(newObject , i)
				}
				else {
					let newObject = Object.assign({} , partModel)
					let newEstimation = Object.assign({} , partEstimation)

					newEstimation.estimation_id = curSearch.estimation_id

					newObject.sparepart_id = curSearch.sparepart_id
					newObject.amount = parseFloat(curSearch.used_amount) * -1
					newObject.name = curSearch.sparepart_name
					newObject.transaction_description = `Pengunaan Sparepart ${curSearch.sparepart_name} Untuk WO ${curSearch.work_order_code}`
					newObject.workorder_code = curSearch.work_order_code
					newObject.price_per_item = parseFloat(curSearch.price_per_item)

					flag = await this.usePart(newObject , newEstimation , curSearch.work_order_code , curSearch.sparepart_name , i)

				}

				if(!flag) {
					break;
				}

				if(this.resultSearch.length  == 0) {
					this.$store.dispatch('triggerAlert' , [true , 'Process Pemakaian Berhasil Tercatat.'])
					this.labourer_id = null
					this.bahanWO = null
				}
			}
			
		},
		async usePart (form , estimation , work_order_code , sparepart_name , index) {
			try {
				let response = await this.$http.patch('/api/v1/purchase-order/' + work_order_code , estimation)

				let price = form.price_per_item ? form.price_per_item * form.amount : 0
				
				form.accountTransaction = [{
					type : 'Accounts Payable',
					amount : price,
					debit_credit : 1,
					description : `PUtang Pembayaran Sparepart ${sparepart_name} Kepada Supplier`
				}]

				let inventoryResponse = await this.$http.post('/api/v1/inventory' , form)

				this.deleteIndexByItem(form.sparepart_id)

				return true
			}
			catch(err) {
				console.log(err)
				// let errObj = err.response.data
				// console.log(errObj)

				this.$store.dispatch('triggerAlert' , [false, `Error. Process ${form.transaction_description} Gagal Tercatat.`])
				return false
			}

		},
		async useBahan(form , index) {
			try {
				let response = await this.$http.post('/api/v1/inventory' , [form])

				this.deleteIndexByItem(form.sparepart_id)

				return true
			}
			catch(err) {
				let errObj = err.response.data
				console.log(errObj)

				this.$store.dispatch('triggerAlert' , [false, `Error. Process ${form.transaction_description} Gagal Tercatat.`])
				return false
			}
		},
		deleteIndexByItem (param) {
			let index = this.resultSearch.findIndex(x => x.sparepart_id == param)

			this.resultSearch.splice(index , 1)
		},
		debounceSearchQRcode : debounce(async (vm) => {
            try {
				let response = await vm.$http.get('/api/v1/inventory/search/qrcode?qrcode=' + vm.qrcode)

				let data = response.data.data

				if(!data[0].sparepart_id)
					throw 'Kode QR Tidak ditemukan'
				
				for(var i = 0 ; i < data.length ; i++) {
					data[i].used_amount = data[i].sparepart_type == 3 ? 0 : data[i].amount
					data[i].work_order_code = data[i].work_order_code ? data[i].work_order_code : null
					
				}

				vm.resultSearch = vm.resultSearch.concat(data)
				vm.qrcode = ''
			}
			catch(err) {
				if(typeof err == 'object') err = err.response.data.data
				vm.$store.dispatch('triggerAlert' , [false , err])
				vm.qrcode = ''
				console.log(err)
			}
        } , 500),
		reloadTable () {
			this.getInventoryUsageWO()
			this.getEstimationDetails()
		},
		async submitPic(image) {
			try {
				let formData = new FormData()

				let data = await fetch(image).then(function(res){return res.arrayBuffer();}).then(function(buf){return new File([buf], 'ttdImage.png',{type:'image/png'});})
				formData.append('image' , data)

                let response = await this.$http.post(env.urlStart + '/api/v1/workorder/steps/upload' , formData , {headers : {"Content-Type":'multipart/form-data'}})
				
				return response.data.data.filename
			}
			catch(err) {
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong When Uploading Image'])
				console.log(err)
				return 'Error'
			}
		},
		getInventoryUsageWO() {
			this.usageList.length = 0
			let vm = this
			// this.usageList 
			this.$http.get('/api/v1/transactions/inventory/work-order/' + this.workOrderCode)
			.then(async (resp) => {
				// console.log(resp.data.data)
				let usageList = resp.data.data
				let obj = []

				for(var i  = 0  ; i < usageList.length ; i++) {
					let sparepartDetail = await vm.loadStock(usageList[i])
					obj.push(sparepartDetail)
				}

				vm.$set(this , 'usageList' , obj)
			})
			.catch((err) => {
				console.log(err)
			})
		},
		async loadStock (estimationPart) {
			try {
				let sparepart_id = estimationPart.sparepart_id ? estimationPart.sparepart_id : estimationPart.spare_part_id

				let queryParam = "k=Spareparts.id&c==&v=" + sparepart_id

				let data = Object.assign({} , estimationPart)

				let resp = await this.$http.get('/api/v1/inventory?' + queryParam)
				console.log(resp)
				data.stock = parseFloat(resp.data.data[0].stocks)
				data.inventoryDetails = resp.data.data[0]
				return data
			}
			catch(err) {
				console.log(err)
			}
		},
		getListOfWorkOrder () {
			this.woList = null;
			this.$http.get('/api/v1/masterData/workorder?pagination=false&is_approved=true')
			.then((resp) => {
				this.woList = resp.data.data

				for(var i = 0; i < this.woList.length; i++) {
					// console.log(this.woList[i].car_name)
					this.woList[i].col_name = this.woList[i].form_code + ' - ' + this.woList[i].no_polisi + ' - ' + this.woList[i].car_name
				}
			})
			.catch((err) => { console.log(err) })
		},
		async getPurchaseOrderDetails () {
			let result = await this.$http.get('/api/v1/purchase-order/' + this.workOrderCode)

			return result.data.data
			
		},
		getEstimationDetails () {
			this.estimatorSparepartData = null;
			this.$http.get('/api/v1/workorder-estimation/' + this.workOrderCode)
			.then( async (resp) => {
				// this.estimatorSparepartData = resp.data.data.estimations
				let estimations = resp.data.data.estimations
				let data = []
				let dataJasa = []
				this.estimation_id = resp.data.data.details.id

				let listOfPO = await this.getPurchaseOrderDetails()

				for(var i = 0 ; i < estimations.length ; i++) {
					// console.log(estimations[i])
					estimations[i].amount = parseFloat(estimations[i].amount)
					if((estimations[i].sparepart_type == 'P') && estimations[i].is_approved_by_insurance) {
						estimations[i] = await this.loadStock(estimations[i])
						// console.log(listOfPO , estimations[i])
						// console.log(listOfPO.find(x => x.estimation_id == estimations[i].id))
						let poDetails = listOfPO.find(x => x.estimation_id == estimations[i].id && !x.next_purchase_order_item)
						if(poDetails) {
							estimations[i].is_po = true
							estimations[i].is_used = poDetails.is_used
							estimations[i].is_arrived = poDetails.is_arrived
						}
						else {
							estimations[i].is_po = false
						}

						
						
						data.push(estimations[i])
						// this.reloadTable = true
						// this.reloadTable = false
					}
					else {
						dataJasa.push(estimations[i])
					}
					
				}
				this.jasaList = dataJasa
				this.estimatorSparepartData = data
				
			})
			.catch((err) => { console.log(err) })
		}
	}
}
</script>

<style scoped>
	.table td {
		vertical-align: middle;
	}

	.middleMargin {
		margin-top: auto;
		margin-bottom: auto;
	}

	.flexify {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.bg-lg-grey {
		background-color: blanchedalmond;
	}
</style>